"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.exposeOnPageChange = exposeOnPageChange;
exports.logCheckpointOnPageChange = logCheckpointOnPageChange;
exports.exposeViaAjax = exposeViaAjax;
exports.logCheckpointViaAjax = logCheckpointViaAjax;

var _isNil = _interopRequireDefault(require("lodash/isNil"));

var _assignIn = _interopRequireDefault(require("lodash/assignIn"));

var _cookiesJs = _interopRequireDefault(require("cookies-js"));

var _featureDetection = require("@eb/feature-detection");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CHECKPOINT_COOKIE_NAME = 'janus_cp';
var EXPOSURE_COOKIE_NAME = 'janus_re';
var EXPIRATION_MINUTES = 5;
var AJAX_CHECKPOINT_URL = '/ajax/janus/checkpoint/';
var AJAX_EXPOSURE_URL = '/ajax/janus/exposure/';

function _isCachedHit() {
  var isVarnishHit = (0, _featureDetection.getWindowObject)('eb') && (0, _featureDetection.getWindowObject)('eb').VHit;
  return !(0, _isNil.default)(isVarnishHit);
}

function _getUrlFormattedCheckpointNames(commaSeparatedCheckpointNames) {
  return commaSeparatedCheckpointNames.split(',').map(function (name) {
    return "".concat(name, "=1");
  }).join('&');
}

function _getCSRFToken() {
  return _cookiesJs.default.get('csrftoken');
}

function _getCookieProperties(domain) {
  var expirationDate = new Date();
  expirationDate.setMinutes(expirationDate.getMinutes() + EXPIRATION_MINUTES);
  return {
    expires: expirationDate,
    // Add a leading dot to domain if needed
    domain: domain.charAt(0) !== '.' ? ".".concat(domain) : domain,
    path: '/'
  };
}

function _postAjaxRequest(endpoint, data) {
  var fetch = (0, _featureDetection.getWindowObject)('fetch');

  if (!fetch) {
    // equivalent of a noop but just return an empty promise
    return Promise.resolve();
  }

  var options = {
    method: 'POST',
    body: JSON.stringify(data),
    credentials: 'same-origin',
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRFToken': _getCSRFToken()
    }
  };
  return fetch(endpoint, options);
}
/**
 * Set a cookie to request exposure to a given experiment.
 *
 * Janus middleware looks for this cookie on the next request, and
 * attempts to expose the user to the given experiment. If the
 * user is not enrolled in the experiment s/he will be enrolled.
 *
 * NB: The current implementation only supports exposing to a
 * single experiment per request.
 */


function _setRequestExposureCookie(experimentName, domain) {
  var cookieProperties = _getCookieProperties(domain);

  _cookiesJs.default.set(EXPOSURE_COOKIE_NAME, "v=1&".concat(experimentName, "=1"), cookieProperties);
}
/**
 * Set a cookie to request that a checkpoint be logged.
 *
 * Janus middleware looks for this cookie on the next request, and
 * logs a checkpoint
 *
 * NB: The current implementation only supports logging a single
 * checkpoint
 */


function _setRequestCheckpointCookie(commaSeparatedCheckpointNames, domain) {
  var cookieProperties = _getCookieProperties(domain);

  var formattedcheckpointNames = _getUrlFormattedCheckpointNames(commaSeparatedCheckpointNames);

  _cookiesJs.default.set(CHECKPOINT_COOKIE_NAME, "v=1&".concat(formattedcheckpointNames), cookieProperties);
}
/**
 * Expose user to the given experiment when s/he navigates to
 * the next page.
 */


function exposeOnPageChange(experimentName, domain) {
  if (_isCachedHit()) {
    return;
  }

  _setRequestExposureCookie(experimentName, domain);
}
/**
 * Logs a checkpoint when a user navigates to the next page.
 */


function logCheckpointOnPageChange(commaSeparatedCheckpointNames, domain) {
  if (_isCachedHit()) {
    return;
  }

  _setRequestCheckpointCookie(commaSeparatedCheckpointNames, domain);
}
/**
 * Expose user to the given experiment when not navigating to
 * another page.
 */


function exposeViaAjax(experimentName, domain) {
  if (_isCachedHit()) {
    return Promise.reject();
  }

  var data = _defineProperty({}, experimentName, '1');

  _setRequestExposureCookie(experimentName, domain);

  return _postAjaxRequest(AJAX_EXPOSURE_URL, data);
}
/**
 * Logs a checkpoint when not navigating to another page.
 */


function logCheckpointViaAjax(checkpointName, extendedAttributes) {
  if (_isCachedHit()) {
    return Promise.reject();
  }

  return _postAjaxRequest(AJAX_CHECKPOINT_URL, (0, _assignIn.default)({}, extendedAttributes, {
    checkpointName: checkpointName
  }));
}
//# sourceMappingURL=index.js.map